<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert')">Carl Von
                        Schubert
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/egon-muller')">Egon Müller
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/jj-prum')">J.J. Prüm
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/peter-lauer')">Peter Lauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/van-volxem')">Van Volxem
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken')">
                        Weingut Forstmeister Geltz Zilliken
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch')">Wwe. Dr. H.
                        Thanisch, Erben Thanisch
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Van Volxem</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        C'è stato un tempo, in un passato non troppo lontano, in cui certi vini Riesling erano di più
                        costoso di uno Château Lafitte o di un Margaux. Van Volxem, situato proprio nel centro di
                        Sarr, era uno di questi; e un uomo si è posto l'arduo compito di ripristinare la vigna
                        il loro antico splendore.
                    </div>

                    <div class="howto-title2">Ciò che sale, deve scendere...</div>
                    <div class="howto-text">
                        Originariamente piantato nel Medioevo dai monaci benedettini della regione, il terreno era
                        acquisito dopo la secolarizzazione napoleonica dalle famiglie Rheinart e Gebert. Insieme loro
                        piantò i ripidi pendii con uve Riesling e, nel 1890, Van Volxem era un leader nel
                        età d'oro del vino Riesling. Tuttavia, le fortune sono improvvisamente svanite, l'economia è andata a gambe all'aria e due
                        le guerre mondiali assicurarono che i tempi non sarebbero cambiati tanto presto. Purtroppo, negli anni '70, il
                        la regione un tempo famosa di Geisberg non aveva quasi più viti.
                    </div>

                    <div class="howto-title2">... e sali di nuovo</div>
                    <div class="howto-text">
                        Dopo quattro generazioni nella famiglia Van Volxem, la tenuta fu venduta a Roman Niewodniscanski in
                        2004. Insieme a Dominik Völk, l'ex enologo di Van Volxem, e Markus Molitor, un amico
                        e collega viticoltore, il trio ha raccolto l'enorme sfida di ripiantare il
                        Tenuta di 60 ettari. Anche se Niewodniscanski ha abbandonato l'idea di utilizzare il sistema Pradikat
                        (dove i vini Riesling di qualità sono classificati in base allo stile), è tornato alla tradizione
                        metodi, quali: basse rese per ceppo, selezione rigorosa, nessuna vendemmia non prima di metà ottobre (se
                        possibile), maturazione fisiologica e fermentazione spontanea. Ovviamente anche questo vale
                        per tutti i vini della tenuta, dall'entry-level ai Grand Crus (o Grosse Lagen in tedesco).
                    </div>

                    <div class="howto-title2">Il futuro è luminoso</div>
                    <div class="howto-text">
                        È ancora presto per Van Volxem ma tutte le indicazioni sembrano buone. Ottimi punteggi anno
                        anno dopo anno, fantastico rapporto qualità-prezzo. Tuttavia, gli investitori di vino con gli occhi lucidi lo faranno senza dubbio
                        sappi che puoi ancora trovare una piccolissima quantità di vino delle annate più povere, incredibilmente raro
                        e incredibilmente costoso, una mezza bottiglia di Van Volxem Scharzhofberger Riesling Eiswein del 1983
                        Goldkapsel è qualcosa nella regione di € 350 (maggio 2019). I prezzi sono rimasti stabili con a
                        piccolo calo in 24 mesi.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Nel gennaio 2019, l'articolo del NY Times dal titolo appropriato "'Disgusting to Say, but It's the
                                Verità: i produttori di vino tedeschi vedono un vantaggio nel cambiamento climatico ", il proprietario Niewodniczanski è registrato
                                affermando (della vendemmia 2018) "quest'anno sarà storico". Anche se troppo presto per
                                sai quanto saranno fantastici gli anni 2018, ci sono buone probabilità che questo sia un vintage simile
                                nessun altro per Van Volxem.
                            </li>
                            <li>Il recente investimento multimilionario di Van Volxem per l'acquisizione e la ricoltivazione di Geisberg; 12 acri all'interno di una valle più fresca e stretta con pendii ripidi da 55 a 65 gradi promettono maggiori opportunità sia per gli investitori che per gli enofili, con il primo Van Volxem Ockfener Geisberg previsto per il 2019.
                            </li>
                            <li>Considerato "il miglior vino secco dell'annata", Scharzhofberger Pergentsknopp 2012
                                ha ricevuto un punteggio di 94 con Vinous e 92 punti da Jean Fisch & David che in seguito
                                ha assegnato all'annata 2016 93 punti, i suoi prezzi sono aumentati di quasi il 40% nel corso di
                                due anni da giugno 2017.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Van Volxem</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Es gab einmal eine Zeit, vor nicht allzu langer Zeit, in der bestimmte Rieslingweine mehr waren
                        teurer als ein Château Lafitte oder ein Margaux. Van Volxem, mitten im Zentrum gelegen
                        Sarr war einer davon; und ein Mann hat sich die schwierige Aufgabe gestellt, den Weinberg wiederherzustellen
                        ihren früheren Glanz.
                    </div>

                    <div class="howto-title2">Was hochgeht, muss auch runterkommen...</div>
                    <div class="howto-text">
                        Das Land wurde ursprünglich im Mittelalter von den Benediktinermönchen der Region bepflanzt
                        nach der napoleonischen Säkularisation von den Familien Rheinart und Gebert erworben. Zusammen sie
                        bepflanzte die Steilhänge mit Riesling-Trauben und in den 1890er Jahren war Van Volxem führend in diesem Bereich
                        Goldenes Zeitalter des Rieslingweins. Doch plötzlich schwand das Vermögen, die Wirtschaft geriet ins Wanken
                        Weltkriege sorgten dafür, dass sich die Zeiten so schnell nicht ändern würden. Leider wurde in den 1970er Jahren die
                        In der einst berühmten Region Geisberg gab es kaum noch Reben.
                    </div>

                    <div class="howto-title2">... und wieder hoch</div>
                    <div class="howto-text">
                        Nach vier Generationen im Besitz der Familie Van Volxem wurde das Anwesen 1990 an Roman Niewodniscanski verkauft
                        2004. Zusammen mit Dominik Völk, dem ehemaligen Winzer bei Van Volxem, und Markus Molitor, einem Freund
                        und Weinbaukollege, das Trio hat sich der großen Herausforderung der Neubepflanzung gestellt
                        60 Hektar großes Anwesen. Obwohl Niewodniscanski die Idee, das Pradikat-System zu verwenden, aufgegeben hat
                        (wo hochwertige Rieslingweine nach Stil klassifiziert werden) ist er zur Tradition zurückgekehrt
                        Methoden wie: geringe Erträge pro Rebe, strenge Selektion, keine Ernte nicht vor Mitte Oktober (falls möglich).
                        möglich), physiologische Reife und spontane Gärung. Das gilt natürlich auch
                        für alle Weine des Weinguts, vom Einstiegswein bis zum Grand Cru (oder Grosse Lagen auf Deutsch).
                    </div>

                    <div class="howto-title2">Die Zukunft ist rosig</div>
                    <div class="howto-text">
                        Für Van Volxem steht es noch am Anfang, aber alle Anzeichen sehen gut aus. Jahr mit hervorragenden Ergebnissen
                        Jahr für Jahr ein fantastisches Preis-Leistungs-Verhältnis. Schlauäugige Weininvestoren werden dies jedoch zweifellos tun
                        Beachten Sie, dass es immer noch sehr kleine Mengen Wein aus den ärmeren Jahren gibt, unglaublich selten
                        und unglaublich teuer, eine halbe Flasche Van Volxem Scharzhofberger Riesling Eiswein aus dem Jahr 1983
                        Goldkapsel kostet etwa 350 € (Mai 2019). Die Preise sind mit a stabil geblieben
                        kleiner Rückgang in 24 Monaten.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Im Januar 2019 erschien der treffend betitelte Artikel der NY Times „‘Disgusting to Say, but It’s the
                                „Wahrheit“: Deutsche Winzer sehen Segen im Klimawandel“, gibt Inhaber Niewodniczanski zu Protokoll
                                mit der Aussage (zur Ernte 2018): „Dieses Jahr wird historisch“. Allerdings zu früh dafür
                                Wenn Sie wissen, wie großartig die 2018er Jahre sein werden, besteht eine gute Chance, dass dies ein Vintage-ähnlicher Jahrgang wird
                                kein anderer für Van Volxem.
                            </li>
                            <li>Van Volxems jüngste Investition in Höhe von mehreren Millionen Euro in den Erwerb und die Rekultivierung von Geisberg; 12 Hektar in einem kühleren, engen Tal mit steilen Hängen mit einer Neigung von 55 bis 65 Grad versprechen mehr Möglichkeiten für Investoren und Önophile, wobei der erste Van Volxem Ockfener Geisberg für 2019 erwartet wird.
                            </li>
                            <li>Gilt als „der beste halbtrockene Wein des Jahrgangs“, 2012 Scharzhofberger Pergentsknopp
                                erhielt eine Punktzahl von 94 mit Vinous und 92 Punkte von Jean Fisch & David, die später
                                Der Jahrgang 2016 wurde mit 93 Punkten bewertet, die Preise stiegen im Laufe des Jahres um fast 40 %
                                zwei Jahre ab Juni 2017.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Van Volxem</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Il était une fois, dans un passé pas trop lointain, où certains vins de Riesling étaient plus
                        cher qu'un Château Lafitte ou un Margaux. Van Volxem, situé en plein centre de
                        Sarr, était l'un d'entre eux; et un homme s'est fixé la lourde tâche de restaurer le vignoble
                        leur ancienne gloire.
                    </div>

                    <div class="howto-title2">Ce qui monte doit redescendre...</div>
                    <div class="howto-text">
                        Planté à l'origine au Moyen-Age par les moines bénédictins de la région, le terrain a été
                        acquis après la sécularisation napoléonienne par les familles Rheinart et Gebert. Ensemble, ils
                        planté les pentes abruptes avec des raisins Riesling, et dans les années 1890, Van Volxem était un chef de file dans le
                        l'âge d'or du Riesling. Cependant, les fortunes se sont soudainement évanouies, l'économie s'est effondrée et deux
                        les guerres mondiales garantissaient que les temps ne changeraient pas de si tôt. Malheureusement, dans les années 1970, le
                        la région autrefois célèbre de Geisberg n'avait presque plus de vignes.
                    </div>

                    <div class="howto-title2">... et remonter</div>
                    <div class="howto-text">
                        Après quatre générations dans la famille Van Volxem, le domaine est vendu à Roman Niewodniscanski en
                        2004. Avec Dominik Völk, l'ancien vigneron de Van Volxem, et Markus Molitor, un ami
                        et collègue viticulteur, le trio a relevé l'immense défi de replanter le
                        Domaine de 60 hectares. Bien que Niewodniscanski ait abandonné l'idée d'utiliser le système Pradikat
                        (où les Riesling de qualité sont classés par style), il revient à la tradition
                        telles que : faibles rendements par cep, sélection stricte, pas de récolte pas avant mi-octobre (si
                        possible), maturité physiologique et fermentation spontanée. Bien sûr, cela est également vrai
                        pour tous les vins du domaine, de l'entrée de gamme aux Grands Crus (ou Grosse Lagen en allemand).
                    </div>

                    <div class="howto-title2">L'avenir est prometteur</div>
                    <div class="howto-text">
                        C'est encore tôt pour Van Volxem mais tout semble bon. Excellentes notes l'année
                        après année, rapport qualité-prix fantastique. Cependant, les investisseurs en vin aux yeux perçants seront sans aucun doute
                        sachez que vous pouvez encore trouver une très petite quantité de vin des années les plus pauvres, incroyablement rare
                        et incroyablement cher, une demi-bouteille de 1983 Van Volxem Scharzhofberger Riesling Eiswein
                        Goldkapsel est quelque chose dans la région de 350 € (mai 2019). Les prix se sont maintenus avec une
                        petite baisse en 24 mois.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>En janvier 2019, l'article du NY Times intitulé "'Disgusting to Say, but It's the
                                Vérité ': les vignerons allemands voient une aubaine dans le changement climatique ", le propriétaire Niewodniczanski est enregistré
                                déclarant (à propos de la récolte 2018) "cette année va être historique". Bien que trop tôt pour
                                sais à quel point les 2018 seront formidables, il y a de fortes chances que ce soit un millésime comme
                                pas d'autre pour Van Volxem.
                            </li>
                            <li>le récent investissement de plusieurs millions d'euros de Van Volxem dans l'acquisition et la remise en culture de Geisberg; 12 acres dans une vallée étroite et plus fraîche de pentes raides de 55 à 65 degrés promet plus d'opportunités pour les investisseurs et les œnophiles, avec le premier Van Volxem Ockfener Geisberg attendu en 2019.
                            </li>
                            <li>Considéré comme "le meilleur vin demi-sec du millésime", 2012 Scharzhofberger Pergentsknopp
                                a reçu un score de 94 avec Vinous, et 92 points de Jean Fisch & David qui plus tard
                                a attribué au millésime 2016 93 points, ses prix augmentant de près de 40% au cours
                                deux ans à compter de juin 2017.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Van Volxem</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        There was once a time, in the not too distant past, where certain Riesling wines were more
                        expensive than a Château Lafitte or a Margaux. Van Volxem, located smack bang in the centre of
                        Sarr, was one of these; and one man has set himself the heady task of restoring the vineyard to
                        their former glory.
                    </div>

                    <div class="howto-title2">What goes up, must come down...</div>
                    <div class="howto-text">
                        Originally planted in the Middle Ages by the Benedictine monks of the region, the land was
                        acquired after Napoleonic secularisation by the Rheinart and Gebert families. Together they
                        planted the steep-slopes with Riesling grapes, and by the 1890s, Van Volxem was a leader in the
                        golden age of Riesling wine. However, fortunes suddenly faded, the economy went belly up and two
                        world wars ensured that times would not be a-changing anytime soon. Sadly, by the 1970s, the
                        once-famous Geisberg region had barely any vines left.
                    </div>

                    <div class="howto-title2">... and go up again</div>
                    <div class="howto-text">
                        After four generations in the Van Volxem family, the estate was sold to Roman Niewodniscanski in
                        2004. Along with Dominik Völk, the former winemaker at Van Volxem, and Markus Molitor, a friend
                        and viticultural colleague, the trio have risen to the huge challenge of replanting the
                        60-hectare estate. Although Niewodniscanski has abandoned the idea of using the Pradikat system
                        (where quality Riesling wines are classified according to style), he has returned to traditional
                        methods, such as: low yields per vine, strict selection, no harvest not before mid-October (if
                        possible), physiological ripeness and spontaneous fermentation. Of course, this also holds true
                        for all the estate's wines, from entry-level to Grand Crus (or Grosse Lagen in German).
                    </div>

                    <div class="howto-title2">The future’s bright</div>
                    <div class="howto-text">
                        It is still early days for Van Volxem but all the indications look good. Excellent scores year
                        after year, fantastic quality-price rapport. However, beady-eyed wine investors will undoubtedly
                        know that you can still find a very small amount of wine from the poorer years, incredibly rare
                        and incredibly expensive, a half bottle of 1983 Van Volxem Scharzhofberger Riesling Eiswein
                        Goldkapsel is something in the region of €350 (May 2019). Prices have been holding steady with a
                        small drop in 24-months.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>In January 2019, the aptly titled NY Times article “‘Disgusting to Say, but It’s the
                                Truth’: German Winemakers See Boon in Climate Change” owner Niewodniczanski is on record
                                stating (of the 2018 harvest) “this year is going to be historic”. Though too soon to
                                know just how great the 2018s will be, there is good chance this will be a vintage like
                                no other for Van Volxem.
                            </li>
                            <li>Van Volxem’s recent multi-million euro investment in acquiring and re-cultivating Geisberg; 12 acres within a cooler, narrow valley of steep 55 to 65 degrees slopes promises more opportunities for investors and oenophiles alike, with the first Van Volxem Ockfener Geisberg expected in 2019.
                            </li>
                            <li>Considered “the best off-dry wine of the vintage”, 2012 Scharzhofberger Pergentsknopp
                                received a score of 94 with Vinous, and 92 points from Jean Fisch & David who later
                                awarded the 2016 vintage 93 points, its prices increasing nearly 40% over the course of
                                two years from June 2017.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VanVolxem",
    data() {
        return {
            select: {report: 'Van Volxem', src: '/wine-guide/germany/mosel-saar-ruwer/van-volxem'},
            items: [
                {report: 'Carl Von Schubert', src: '/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert'},
                {report: 'Egon Müller', src: '/wine-guide/germany/mosel-saar-ruwer/egon-muller'},
                {report: 'J.J. Prüm', src: '/wine-guide/germany/mosel-saar-ruwer/jj-prum'},
                {report: 'Peter Lauer', src: '/wine-guide/germany/mosel-saar-ruwer/peter-lauer'},
                {report: 'Van Volxem', src: '/wine-guide/germany/mosel-saar-ruwer/van-volxem'},
                {
                    report: 'Weingut Forstmeister Geltz Zilliken',
                    src: '/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken'
                },
                {
                    report: 'Wwe. Dr. H. Thanisch, Erben Thanisch',
                    src: '/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Van Volxem | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines of Van Volxem, a leading wine producer in the Mosel region known for their exquisite Rieslings and sparkling wines. Indulge in a taste of tradition and quality with every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
